import { isPlainObject, size } from 'lodash-es'

const NEW_OPERATORS = ['_eq', '_gt', '_gte', '_lt', '_lte', '_between', '_in']
const LEGACY_OPERATORS = ['eq', 'gt', 'gte', 'lt', 'lte', 'between', 'in']
const OPERATOR_MAP = {
  'eq': '_eq',
  'gt': '_gt',
  'gte': '_gte',
  'lt': '_lt',
  'lte': '_lte',
  'between': '_between',
  'in': '_in',
}
const LOGICAL_OPERATORS = ['_and', '_or']

export default function transpile(condition) {
  if (!isPlainObject(condition) || Object.keys(condition).includes('func')) return condition

  const parts = Object.entries(condition)
    .map(([key, value]) => transpile_entry(key, value))
    .filter(e => Object.keys(e).length > 0)

  if (parts.length === 0) return {}
  if (parts.length === 1) return parts[0]
  return { _and: parts }
}

function transpile_entry(key, value) {
  if (LOGICAL_OPERATORS.includes(key)) {
    return Array.isArray(value) ? { [key]: value.map((v) => transpile(v)) } : { [key]: value }
  }

  if (key === '_not') {
    if (isPlainObject(value)) {
      return { [key]: transpile(value) }
    } else if (Array.isArray(value)) {
      return { [key]: value.map((v) => transpile(v)) }
    } else if (typeof value === 'string') {
      return { [key]: value }
    } else {
      return { [key]: value }
    }
  }

  if (NEW_OPERATORS.includes(key)) {
    return { [key]: value }
  }

  if (legacy_operator(value)) {
    const [legacy, operand] = Object.entries(value)[0]
    return { [OPERATOR_MAP[legacy]]: [key, operand] }
  }

  if (Array.isArray(value)) {
    return { '_in': [key, value] }
  }

  return { '_eq': [key, value] }
}

function legacy_operator(value) {
  return isPlainObject(value) && size(value) === 1 && LEGACY_OPERATORS.includes(Object.keys(value)[0])
}
